import { Link } from "react-router-dom";
import { Upload, Palette, MessageCircle, CalendarDays, MapPin, Clapperboard } from "lucide-react";
import { TdvPricing } from "@/threedvista/TdvPricing";

const FEATURES = [
  [Upload, "Upload the published folder", "Zip the folder 3DVista publishes and drop it in. Every scene is read automatically."],
  [Palette, "Your brand around the tour", "Your logo, colours, start screen and a scene menu that matches."],
  [MapPin, "Hotspots that stay put", "Click anywhere in a 360° scene to pin info, photos and links."],
  [Clapperboard, "A cinematic opening", "Captions that cut between your best scenes before the tour starts."],
  [MessageCircle, "An AI assistant", "Answers visitor questions from your tour details, day and night."],
  [CalendarDays, "Viewing requests", "Visitors book a viewing and you get the lead straight away."],
];

export default function TdvHome() {
  const signup = "/3dvista/signup";
  return (
    <div className="min-h-screen bg-[#0B1220] text-white" data-testid="tdv-home">
      <header className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/3dvista" className="font-serif text-xl" data-testid="tdv-home-logo">Showhome <span className="text-[#C9A227]">for 3DVista</span></Link>
        <div className="flex items-center gap-2">
          <a href="#pricing" className="h-10 px-4 rounded-full text-sm font-semibold hover:bg-white/10 grid place-items-center" data-testid="tdv-home-pricing">Pricing</a>
          <Link to="/3dvista/login" className="h-10 px-4 rounded-full text-sm font-semibold hover:bg-white/10 grid place-items-center" data-testid="tdv-home-login">Log in</Link>
          <Link to={signup} className="h-10 px-5 rounded-full bg-[#C9A227] text-slate-950 text-sm font-semibold grid place-items-center" data-testid="tdv-home-signup">Sign up</Link>
        </div>
      </header>
      <section className="max-w-6xl mx-auto px-6 pt-16 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C9A227] rise">For 3DVista creators</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl max-w-3xl mt-5 leading-[1.05] rise">Turn your 3DVista tour into an interactive selling experience.</h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mt-6 rise">You already built the tour. Upload it once and add your branding, hotspots, a cinematic opening, an AI assistant and viewing requests. No rebuilding required.</p>
        <div className="flex flex-wrap gap-3 mt-10 rise">
          <Link to="/3dvista/try" className="h-12 px-7 rounded-full bg-[#C9A227] text-slate-950 font-semibold grid place-items-center hover:opacity-90 transition-opacity" data-testid="tdv-home-try">Try it on your own tour</Link>
          <Link to={signup} className="h-12 px-7 rounded-full border border-white/20 font-semibold grid place-items-center hover:bg-white/10 transition-colors" data-testid="tdv-home-cta">Create your account</Link>
          <Link to="/3dvista/login" className="h-12 px-7 rounded-full border border-white/20 font-semibold grid place-items-center hover:bg-white/10 transition-colors">Log in</Link>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 pb-28 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map(([Icon, t, d], i) => (
          <div key={t} className="rounded-3xl border border-white/10 bg-white/[0.03] p-7 rise" style={{ animationDelay: `${i * 60}ms` }} data-testid={`tdv-feature-${i}`}>
            <Icon className="w-6 h-6 text-[#C9A227]" />
            <p className="font-semibold text-lg mt-5">{t}</p>
            <p className="text-sm text-white/60 mt-2">{d}</p>
          </div>
        ))}
      </section>
      <TdvPricing currency="USD" signup={signup} />
    </div>
  );
}
